module.exports = __webpack_public_path__ + "media/packs/images/flags/MR-023ebb90a42be2bce66880cb060dc320.svg";